import watchdog from '@hll/watch-dog-jsutil';
import { UNIQUE_ID } from './uniqueId';

export const sendEvent = (eventName, arg1, arg2) => {
  console.log('eventName==>', eventName, arg1, arg2);

  try {
    arg1 = typeof arg1 !== 'string' ? JSON.stringify(arg1) : arg1;
    arg2 = typeof arg2 !== 'string' ? JSON.stringify(arg2) : arg2;

    watchdog.sendEvent(
      eventName,
      arg1,
      arg2,
      JSON.stringify({
        uniqueId: UNIQUE_ID,
        url: location.href,
        ua: navigator.userAgent
      })
    );
  } catch (e) {
    console.log(e);
  }
};
